import type { StatCardProps } from "@/components/molecules/StatCard";
import { Profile2User, Alarm } from "iconsax-react";

export interface Group {
  id: string;
  name: string;
  creator: string;
  type: "Free" | "Paid";
  price?: number;
  members: number;
  revenue: number;
  location: string;
  createdOn: string;
  status: "Active" | "Expired";
}

export interface ReportedGroup {
  name: string;
  reports: number;
  lastReported: string;
}

export const GROUP_STATS: StatCardProps[] = [
  {
    title: "Total Group",
    value: "12,745",
    icon: <Profile2User variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "Active Group (Last 7D)",
    value: "3,921",
    icon: <Profile2User variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "decrease" },
  },
  {
    title: "Expired Group (30D)",
    value: "1,000",
    icon: <Profile2User variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Paid Group",
    value: "200",
    icon: <Profile2User variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Revenue from Group",
    value: "$12,745",
    icon: <Profile2User variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "Reported Group",
    value: "190",
    icon: <Alarm variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+2 cases", type: "increase" },
  },
];

export const MOCK_GROUPS: Group[] = [
  {
    id: "1",
    name: "Yoga & Tea Mornings",
    creator: "@wellnessgirl",
    type: "Paid",
    price: 2,
    members: 31,
    revenue: 62,
    location: "NY, USA",
    createdOn: "12 Mar 2025",
    status: "Expired",
  },
  {
    id: "2",
    name: "Book Club Night",
    creator: "@tony_reads",
    type: "Free",
    members: 31,
    revenue: 62,
    location: "NY, USA",
    createdOn: "12 Mar 2025",
    status: "Expired",
  },
  {
    id: "3",
    name: "Salsa Singles Night",
    creator: "@dance_africa",
    type: "Paid",
    price: 3,
    members: 31,
    revenue: 62,
    location: "NY, USA",
    createdOn: "12 Mar 2025",
    status: "Expired",
  },
  {
    id: "4",
    name: "Yoga & Tea Mornings",
    creator: "@wellnessgirl",
    type: "Paid",
    price: 2,
    members: 31,
    revenue: 62,
    location: "NY, USA",
    createdOn: "12 Mar 2025",
    status: "Expired",
  },
];

export const MOCK_REPORTED_GROUPS: ReportedGroup[] = [
  {
    name: "Movie Night",
    reports: 3,
    lastReported: "Last 24h",
  },
  {
    name: "Brunch Club",
    reports: 3,
    lastReported: "Last 24h",
  },
];

export const GROUP_TABLE_HEADERS = [
  "Group Name",
  "Creator",
  "Type",
  "Members",
  "Revenue",
  "Location",
  "Created On",
  "Status",
  "",
];
